// src/utils/insertBanners.ts
function insertBanners({
  adItems,
  bannerPositions,
  bannerElements
}) {
  if (!bannerPositions || !bannerElements) {
    return adItems;
  }
  return adItems.flatMap(
    (item, index) => bannerPositions.includes(index) ? [bannerElements[bannerPositions.indexOf(index)], item] : [item]
  );
}

// src/utils/placementName.ts
var ContainerId = /* @__PURE__ */ ((ContainerId2) => {
  ContainerId2["Top2"] = "advt_top_2--container";
  ContainerId2["Middle1"] = "advt_middle_1--container";
  ContainerId2["Middle2"] = "advt_middle_2--container";
  ContainerId2["Bottom1"] = "advt_bottom_1--container";
  ContainerId2["RecircMiddle1"] = "advt_recirc_middle_1--container";
  ContainerId2["RecircMiddle2"] = "advt_recirc_middle_2--container";
  return ContainerId2;
})(ContainerId || {});

// src/hooks/useAdPositionElements.tsx
import React4, { useEffect as useEffect3, useMemo as useMemo2, useState as useState4 } from "react";
import { events as events2, messageBus as messageBus2 } from "@schibsted-nmp/advertising-events";

// src/hooks/useGetPlacementInstructions.ts
import { useEffect, useState } from "react";
import * as React from "react";
import { messageBus, events } from "@schibsted-nmp/advertising-events";
function useGetPlacementInstructions(configType) {
  const [hydrated, setHydrated] = React.useState(false);
  const [placementInstructions, setPlacementInstructions] = useState([]);
  useEffect(() => {
    setHydrated(true);
    const callback = (event) => {
      const payload = events.COMPANION.PODLET_READY.getPayload(event);
      const placementInstructionConfig = payload.placementInstructionConfigs.find(
        (config) => config.type === configType
      );
      setPlacementInstructions(placementInstructionConfig.data);
    };
    const unsubscribe = messageBus.subscribe(
      events.COMPANION.channel,
      events.COMPANION.PODLET_READY.topic,
      callback
    );
    return () => {
      unsubscribe();
    };
  }, []);
  return {
    placementInstructions,
    hydrated
  };
}

// src/hooks/useSearchPositionInstruction.ts
import { useMemo } from "react";
var useSearchPositionInstruction = ({
  layoutType,
  placementInstructions
}) => {
  const bannerLayout = useMemo(
    () => placementInstructions?.find(
      (placemementInstruction) => placemementInstruction.type === layoutType
    ),
    [layoutType, placementInstructions]
  );
  return useMemo(() => {
    let position = 0;
    return bannerLayout?.intervals.map(
      ({ placementId, interval }) => {
        position += interval;
        return {
          containerId: placementId + "--container",
          placementId,
          position
        };
      }
    );
  }, [bannerLayout?.intervals]);
};

// src/components/AdvertisingSlotComponent.tsx
import React2, { useEffect as useEffect2, useState as useState3 } from "react";

// src/utils/injectRecircSlot.ts
function injectRecricSlotInWebComponent(props) {
  const { placementId } = props;
  if (typeof window !== "undefined") {
    const recircSlotId = `${placementId}--recirc-slot`;
    const webComponent = getRecircWebComponent();
    if (webComponent && props) {
      const advtComp = getAdvtWebComponent({
        placementId,
        ...props
      });
      advtComp.setAttribute("slot", recircSlotId);
      advtComp.setAttribute("id", recircSlotId);
      webComponent.appendChild(advtComp);
    }
  }
}
function getRecircWebComponent() {
  return document.querySelector("recommendation-podlet-isolated") || document.querySelector("recommendation-podlet-mock") || document.querySelector("data-podlet-mlt") || document.querySelector("data-podlet-recommend") || // recommendation-podlet-mock is only used to mimic the recirculation slot in the local environment
  // no other layour server or podlet should be defining this web component
  document.querySelector("recommendation-podlet-mock");
}
function getAdvtWebComponent({
  placementId,
  adIndex
}) {
  const webComponent = document.createElement("advt-component");
  webComponent.setAttribute("placementId", placementId);
  webComponent.setAttribute("adIndex", `${adIndex}`);
  return webComponent;
}

// src/components/AdvertisingSlotComponent.tsx
var AdvertisingSlotComponent = ({
  placementId,
  adIndex
}) => {
  const [recircSlotAdded, setRecircSlotAdded] = useState3(false);
  useEffect2(() => {
    if (!recircSlotAdded) {
      injectRecricSlotInWebComponent({ placementId, adIndex });
      setRecircSlotAdded(true);
    }
  }, [placementId, adIndex, recircSlotAdded]);
  return /* @__PURE__ */ React2.createElement("slot", { name: `${placementId}--recirc-slot` });
};

// src/components/AdvertisingWebComponent.tsx
import React3 from "react";
var AdvertisingWebComponent = ({
  placementId,
  adIndex,
  initialLayoutType
}) => {
  return /* @__PURE__ */ React3.createElement(
    "advt-component",
    {
      placementId,
      adIndex,
      initialLayoutType
    },
    /* @__PURE__ */ React3.createElement("div", { id: `${placementId}--container`, slot: `${placementId}--slot` })
  );
};

// src/hooks/useAdPositionElements.tsx
function useAdPositionElements({
  layoutType,
  type
}) {
  const [bannerPositions, setBannerPositions] = useState4([]);
  const [bannerElements, setBannerElements] = useState4([]);
  const { placementInstructions } = useGetPlacementInstructions(type);
  const positionData = useSearchPositionInstruction({
    layoutType,
    placementInstructions
  });
  const adList = useMemo2(() => {
    return positionData?.map(({ placementId, position }, i) => {
      return {
        element: type === "recommendation" ? /* @__PURE__ */ React4.createElement(
          AdvertisingSlotComponent,
          {
            placementId,
            adIndex: i,
            key: placementId + i
          }
        ) : /* @__PURE__ */ React4.createElement(
          AdvertisingWebComponent,
          {
            placementId,
            adIndex: i,
            key: placementId + i,
            initialLayoutType: layoutType
          }
        ),
        position
      };
    });
  }, [positionData, type, layoutType]);
  useEffect3(() => {
    if (positionData?.length > 0) {
      setBannerPositions(positionData.map(({ position }) => position));
    }
  }, [positionData]);
  useEffect3(() => {
    messageBus2.publish(
      events2.COMPANION.channel,
      events2.COMPANION.LAYOUT_TYPE_CHANGE.topic,
      {
        layoutType
      }
    );
  }, [layoutType]);
  useEffect3(
    function createBannerElementsThatPersistAcrossReRenders() {
      if (adList) {
        setBannerPositions((prevPositions) => {
          return prevPositions.length > 0 ? prevPositions : adList.map(({ position }) => position);
        });
        setBannerElements((prevElements) => {
          return prevElements.length > 0 ? prevElements : adList.map(({ element }) => element);
        });
      }
    },
    [adList, setBannerPositions, setBannerElements]
  );
  return [bannerPositions, bannerElements];
}

// src/hooks/useAdList.ts
function useAdList({ adItems, type, layoutType }) {
  const [bannerPositions, bannerElements] = useAdPositionElements({
    type,
    layoutType
  });
  return insertBanners({ adItems, bannerPositions, bannerElements });
}

// src/components/AdvertisingPlacement.tsx
import React5, { useRef } from "react";

// src/components/advertising-placement-hooks/useAdStylesSub.ts
import { useEffect as useEffect4, useState as useState5 } from "react";
import { events as events3, messageBus as messageBus3 } from "@schibsted-nmp/advertising-events";
function useAdStylesSub(containerId) {
  const [adStyles, setAdStyles] = useState5();
  useEffect4(() => {
    const unsubscribe = messageBus3.subscribe(
      events3.COMPANION.channel,
      events3.COMPANION.AD_STYLES.topic,
      (e) => {
        const payload = events3.COMPANION.AD_STYLES.getPayload(e);
        if (payload.containerId === containerId) {
          setAdStyles(payload);
        }
      }
    );
    return () => {
      if (unsubscribe)
        unsubscribe();
    };
  }, []);
  return adStyles;
}

// src/components/advertising-placement-hooks/useContainerLoadedCallback.ts
import { useEffect as useEffect5, useState as useState6 } from "react";
function useContainerLoadedCallback(ref, elementRenderedCallback) {
  const [rendered, setRendered] = useState6(false);
  useEffect5(() => {
    if (rendered && elementRenderedCallback && ref.current) {
      elementRenderedCallback(ref.current);
    }
    setRendered(true);
  }, [elementRenderedCallback, ref.current, rendered]);
}

// src/components/AdvertisingPlacement.tsx
var AdvertisingPlacement = ({
  containerId,
  elementRenderedCallback,
  customClassNames = "",
  enableHeightCache = false,
  isSlot = false,
  ...rest
}) => {
  const containerRef = useRef(null);
  const adStyle = useAdStylesSub(containerId);
  useContainerLoadedCallback(containerRef, elementRenderedCallback);
  const style = adStyle?.style || {};
  const className = `relative overflow-hidden ${adStyle?.className || ""} ${customClassNames}`;
  if (isSlot) {
    return /* @__PURE__ */ React5.createElement("div", { ref: containerRef, className, style }, /* @__PURE__ */ React5.createElement("slot", { name: containerId, ...rest }));
  } else {
    return /* @__PURE__ */ React5.createElement(
      "div",
      {
        id: containerId,
        style,
        className,
        ...rest,
        ref: containerRef
      }
    );
  }
};
export {
  AdvertisingPlacement,
  AdvertisingSlotComponent,
  AdvertisingWebComponent,
  ContainerId,
  insertBanners,
  useAdList,
  useAdPositionElements
};
